import { inject } from '@angular/core';
import { ActivatedRoute, CanMatchFn, UrlSegment } from '@angular/router';
import { FunnelFlowService } from '../services/funnel-flow.service';
import { ScreenType } from './flow-config';

/**
 * Matches quiz/:index only when the flow puts a screen of `type` at that index, so the routes can
 * map every screen type to its component under one URL scheme.
 */
export function flowScreenIs(type: ScreenType): CanMatchFn {
  return (_route, segments: UrlSegment[]) =>
    inject(FunnelFlowService).getScreen(parseInt(segments[1].path, 10))?.type === type;
}

// The flow position of the screen being rendered, for components routed under quiz/:index.
export function injectScreenIndex(): number {
  return parseInt(inject(ActivatedRoute).snapshot.paramMap.get('index') ?? '0', 10);
}
